import { FC, PropsWithChildren } from "react";

import { RydeUiUnit, TPermissionAction, useHasPermissions } from "@ryde/shared";

interface IAccessControlProps extends PropsWithChildren {
  entity?: RydeUiUnit;
  action?: TPermissionAction;
}

export const AccessControl: FC<IAccessControlProps> = ({
  entity,
  action,
  children,
}: IAccessControlProps) => {
  const { hasPermissions } = useHasPermissions({ entity, action });

  if (!hasPermissions) {
    return null;
  }

  return children;
};
